import { render, staticRenderFns } from "./SEOAudit.vue?vue&type=template&id=128f5e11"
import script from "./SEOAudit.vue?vue&type=script&lang=js"
export * from "./SEOAudit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports